import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const FltDptCategoryList = styled.div`
  .list {
    ${mixin.flex({ wrap: 'wrap', justify: 'flex-start', align: 'flex-start' })};
    row-gap: 4px;

    .item {
      width: 50%;
    }
  }

  .path {
    ${mixin.flex({ justify: 'flex-start' })};
    column-gap: 2px;
    padding: 6px 0;
    margin-bottom: 8px;

    .item {
      ${mixin.flex({ justify: 'flex-start' })};
    }

    .btn {
      font-size: 16px;
      font-weight: 500;
      line-height: 130%;
      color: #999;
    }

    .icon {
      ${mixin.flex({ display: 'inline-flex' })};
      margin: 0 2px;
      width: 16px;
      height: 16px;
    }

    .item:last-child {
      .btn {
        color: #000;
      }
    }
  }

  .path + .list .item {
    .btn-text {
      height: 35px;
    }

    .text {
      font-size: 15px;
    }

    .cnt {
      font-size: 14px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .list {
      row-gap: ${mixin.pxToVw('4')};
    }

    .path {
      column-gap: ${mixin.pxToVw('2')};
      padding: ${mixin.pxToVw('6 0')};
      margin-bottom: ${mixin.pxToVw('8')};

      .btn {
        font-size: ${mixin.pxToVw('16')};
      }

      .icon {
        margin: ${mixin.pxToVw('0 2')};
        width: ${mixin.pxToVw('16')};
        height: ${mixin.pxToVw('16')};
      }
    }

    .path + .list .item {
      .btn-text {
        height: ${mixin.pxToVw('35')};
      }

      .text {
        font-size: ${mixin.pxToVw('15')};
      }

      .cnt {
        font-size: ${mixin.pxToVw('14')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .path {
      column-gap: 3px;

      .btn {
        font-size: 17px;
      }

      .icon {
        margin: 0 3px;
        width: 18px;
        height: 18px;

        svg {
          width: 9px;
          height: 14px;
        }
      }
    }

    .path + .list .item {
      .btn-text {
        height: 37px;
      }

      .text {
        font-size: 16px;
      }

      .cnt {
        font-size: 15px;
      }
    }
  }
`;
